'use client';
/**
 * nav_region1 — /apt «재방문 기본값» 띠. 지역 칩에서 고른 지역(kd_nav_region_v1)이 있으면 「최근 고른 지역 ○○ 현장 보기 →」.
 *   · /apt 의 지역 필터 = 색인 허브(/apt/region/{시도} · /apt/area/…) — 다른 URL 이라 자동 이동하지 않는다(NAV14 «자동 이동 없음»).
 *   · 서버 HTML·첫 수화 렌더 = 아무것도 없음(null). 기억은 useEffect 뒤에만 읽는다(봇·일반 동일 HTML · 클로킹 0).
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { useEffect, useState } from 'react';
import { readRegionMemoryEntry, writeRegionMemory } from '@/lib/nav/region-scope';
import { trackRx } from '@/lib/rx/track';
import '@/components/home/home-region.css';

export default function RegionMemoryHint() {
  const [m, setM] = useState<{ code: string; href: string; label: string } | null>(null);
  useEffect(() => {
    const e = readRegionMemoryEntry();
    if (e?.href && e.label) setM({ code: e.code, href: e.href, label: e.label });
  }, []);
  if (!m) return null;
  return (
    <div className="clh-rf-bar" role="region" aria-label="최근 고른 지역" data-region-memory-hint={m.code}>
      <p className="clh-rf-bar__t">최근 고른 지역 <b>{m.label}</b></p>
      <div className="clh-rf-acts">
        <a className="clh-rf-hub" href={m.href} onClick={() => trackRx('region_select_apply', m.code, 'memory-hint:navigated', { target: m.href })}>{m.label} 현장 보기 <span aria-hidden="true">→</span></a>
        <button type="button" className="clh-rf-btn" onClick={() => { writeRegionMemory(null); try { window.dispatchEvent(new Event('kd:region-memory')); } catch { /* 무시 */ } setM(null); }}>전국 유지</button>
      </div>
    </div>
  );
}
